<div class="min-h-screen flex items-center gap-3 justify-center background-jakarta relative">
    <!-- Loading Indicator saat check authentication -->
    <div *ngIf="isCheckingAuth" class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-30 z-10">
        <div class="bg-white w-full max-w-sm rounded-xl shadow-xl p-6">
            <div class="flex flex-col items-center justify-center py-8">
                <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mb-4"></div>
                <p class="text-gray-600 text-sm">Checking authentication...</p>
            </div>
        </div>
    </div>

    <div class="w-full lg:w-1/2 bg-primary-green h-screen hidden lg:flex items-center justify-center">
        <img src="assets/images/pages/login/client-area.png" alt="client-area" class="max-h-120 object-contain" />
    </div>

    <div class="w-full lg:w-1/2 mx-4 lg:mx-0 flex items-center justify-center">
        <!-- Main Login Card -->
        <div *ngIf="!isCheckingAuth && !showServiceSelection" class="bg-white w-full max-w-sm rounded-xl shadow-lg p-6">
            <h1 class="text-center text-4xl font-semibold text-gray-800 mb-6">
                SIGN IN
            </h1>

            <!-- Error Message -->
            <div *ngIf="errorMessage" class="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg">
                {{ errorMessage }}
            </div>

            <form (ngSubmit)="onSignIn()" class="space-y-4">
                <div>
                    <label for="email" class="block text-sm text-gray-600 mb-1 font-semibold">Email</label>
                    <div
                        class="flex items-center w-full px-3 border border-gray-300 rounded-lg focus:border-indigo-500 focus:ring-indigo-500 outline-none text-sm py-3 gap-2 focus-within:ring-2 focus-within:ring-indigo-500">
                        <img src="assets/images/ezgate/icon/team.png" alt="" class="w-5 h-5" />
                        <input id="email" type="email" [(ngModel)]="credentials.email" name="email"
                            class="w-full border-none outline-none text-sm" placeholder="Enter your email"
                            [disabled]="isLoading" required autocomplete="email" autofocus/>
                    </div>
                </div>

                <div>
                    <label for="password" class="block text-sm text-gray-600 mb-1 font-semibold">Password</label>

                    <div
                        class="flex items-center w-full px-3 border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-indigo-500 text-sm py-3 gap-2">
                        <img (click)="showPassword = !showPassword" [src]="
                                showPassword
                                    ? 'assets/images/ezgate/icon/eye-off.svg'
                                    : 'assets/images/ezgate/icon/eye.svg'
                            " class="w-5 h-5 cursor-pointer" />

                        <input id="password" [type]="showPassword ? 'text' : 'password'"
                            [(ngModel)]="credentials.password" name="password"
                            class="w-full border-none outline-none text-sm" placeholder="Enter your password"
                            [disabled]="isLoading" required />
                    </div>
                </div>

                <button type="submit" [disabled]="isLoading"
                    class="w-full py-3 bg-primary-green text-white text-lg font-semibold rounded-lg hover:bg-primary-green-hover transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center">
                    <span *ngIf="!isLoading">Sign In</span>
                    <span *ngIf="isLoading" class="flex items-center">
                        <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                            </path>
                        </svg>
                        Signing in...
                    </span>
                </button>
            </form>

            <p class="text-gray-500 text-sm text-center mt-4">
                © 2026
                <span class="font-semibold">AWH </span>
                . Powered by
                <span class="font-semibold">PT. AWH Inti Nusantara. </span>
            </p>
        </div>

        <!-- Service Selection Card -->
        <div *ngIf="showServiceSelection" class="bg-white w-full max-w-sm rounded-xl shadow-lg p-6 animate-fade-in-up">
            <h2 class="text-center text-2xl font-semibold text-gray-800 mb-2">Select Service</h2>
            <p class="text-center text-gray-500 mb-6 text-sm">Please choose a service to continue</p>

            <div class="space-y-3">
                <button *ngFor="let service of availableServices"
                        (click)="selectService(service)"
                        class="w-full p-4 border border-gray-200 rounded-xl hover:border-primary-green hover:bg-gray-50 transition-all duration-200 flex items-center gap-4 group text-left">
                    <div class="w-10 h-10 rounded-full bg-primary-green/10 flex items-center justify-center group-hover:bg-primary-green/20 transition-colors">
                        <!-- Icon Placeholder based on service code -->
                        <div [ngSwitch]="service.code">
                            <span *ngSwitchCase="'parking'" class="text-primary-green font-semibold">P</span>
                            <span *ngSwitchCase="'ticketing'" class="text-primary-green font-semibold">T</span>
                            <span *ngSwitchDefault class="text-primary-green font-semibold">{{ service.name.charAt(0) }}</span>
                        </div>
                    </div>
                    <div>
                        <h3 class="font-semibold text-gray-800">{{ service.name }}</h3>
                        <p class="text-xs text-gray-500">Access {{ service.name }} Dashboard</p>
                    </div>
                    <div class="ml-auto text-gray-400 group-hover:text-primary-green">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                        </svg>
                    </div>
                </button>
            </div>

            <button (click)="showServiceSelection = false; credentials.password = '';" class="mt-6 text-sm text-gray-500 hover:text-gray-700 w-full text-center">
                ← Back to Login
            </button>
        </div>
    </div>

    <!-- Login Form -->
</div>
